import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Flex, Tooltip } from '@mantine/core';
export const MRT_ColumnPinningButtons = ({ column, table, }) => {
    const { options: { icons: { IconPinned, IconPinnedOff }, localization, }, } = table;
    const handlePinColumn = (pinDirection) => {
        column.pin(pinDirection);
    };
    return (_jsx(Flex, { sx: {
            minWidth: '70px',
            alignContent: 'center',
            justifyContent: 'center',
        }, children: column.getIsPinned() ? (_jsx(Tooltip, { withinPortal: true, label: localization.unpin, children: _jsx(ActionIcon, { onClick: () => handlePinColumn(false), size: "md", children: _jsx(IconPinnedOff, {}) }) })) : (_jsxs(_Fragment, { children: [_jsx(Tooltip, { withinPortal: true, label: localization.pinToLeft, children: _jsx(ActionIcon, { onClick: () => handlePinColumn('left'), size: "md", children: _jsx(IconPinned, { style: {
                                transform: 'rotate(90deg)',
                            } }) }) }), _jsx(Tooltip, { withinPortal: true, label: localization.pinToRight, children: _jsx(ActionIcon, { onClick: () => handlePinColumn('right'), size: "md", children: _jsx(IconPinned, { style: {
                                transform: 'rotate(-90deg)',
                            } }) }) })] })) }));
};
//# sourceMappingURL=MRT_ColumnPinningButtons.js.map